module.exports = __webpack_public_path__ + "img/premio1.01f7a236.png";